import axios from 'axios';

/** The kinds of failure that get their own full-page treatment. */
export type ErrorStatus = 'not-found' | 'forbidden' | 'server' | 'offline' | 'unknown';

/** The HTTP status of a failed request, or undefined when there was no response. */
export function getHttpStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

/**
 * Sorts any thrown value into an `ErrorStatus`. A request that never got a
 * response is `offline`; anything that isn't a request failure (a render crash,
 * a bug) is `unknown`.
 */
export function getErrorStatus(error: unknown): ErrorStatus {
  if (!axios.isAxiosError(error)) return 'unknown';

  const status = error.response?.status;
  if (status === undefined) {
    if (error.code === 'ERR_NETWORK' || !navigator.onLine) return 'offline';
    // The server was reached but too slow to answer, which reads as a server problem.
    if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') return 'server';
    return 'unknown';
  }
  if (status === 404 || status === 410) return 'not-found';
  if (status === 403) return 'forbidden';
  if (status >= 500) return 'server';
  return 'unknown';
}
